import { render } from "./ButtonSubmit.vue?vue&type=template&id=7075bf7c&scoped=true"
import script from "./ButtonSubmit.vue?vue&type=script&lang=js"
export * from "./ButtonSubmit.vue?vue&type=script&lang=js"

import "./ButtonSubmit.vue?vue&type=style&index=0&id=7075bf7c&scoped=true&lang=css"

import exportComponent from "C:\\www\\mutual-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7075bf7c"]])

export default __exports__